"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetFilters = exports.setFilterValue = exports.loadFilters = exports.filterMapping = exports.DEFAULT_FILTER_VALUES = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.DEFAULT_FILTER_VALUES = {
    brand_name: 'Все марки',
    model_name: 'Все модели',
    generation_name: 'Поколение',
    year_from: 'Год от',
    max_price: 'Цена до',
    engine_name_type_name: 'Двигатель',
    gearbox_type_name: 'КПП',
    body_type_name: 'Тип кузова',
    drive_type_name: 'Привод',
    owners_count: 'Владельцев',
};
exports.filterMapping = {
    brand_name: 'brand_name',
    model_name: 'model_name',
    generation_name: 'generation_name',
    year_from: 'year_from',
    max_price: 'max_price',
    engine_name_type_name: 'engine_name_type_name',
    gearbox_type_name: 'gearbox_type_name',
    body_type_name: 'body_type_name',
    drive_type_name: 'drive_type_name',
    owners_count: 'owners_count',
};
exports.loadFilters = (0, toolkit_1.createAsyncThunk)('filters/loadFilters', function (params, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, url, response, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    queryParams = new URLSearchParams();
                    Object.entries(params).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (value && key in exports.filterMapping) {
                            queryParams.append(exports.filterMapping[key], value);
                        }
                    });
                    url = "".concat(process.env.REACT_APP_BASE_URL, "/filters?").concat(queryParams.toString());
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        throw new Error('Ошибка сервера');
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, data];
                case 3:
                    error_1 = _b.sent();
                    return [2 /*return*/, rejectWithValue('Ошибка загрузки фильтров')];
                case 4: return [2 /*return*/];
            }
        });
    });
});
var initialState = {
    values: {
        brand_name: null,
        model_name: null,
        generation_name: null,
        year_from: null,
        max_price: null,
        engine_name_type_name: null,
        gearbox_type_name: null,
        body_type_name: null,
        drive_type_name: null,
        owners_count: null,
    },
    state: {
        isLoading: false,
        filtersList: [],
        error: null,
        carCount: null,
    },
};
var filterSlice = (0, toolkit_1.createSlice)({
    name: 'filter',
    initialState: initialState,
    reducers: {
        setFilterValue: function (state, action) {
            state.values[action.payload.key] = action.payload.value;
            if (action.payload.key === 'brand_name') {
                state.values.model_name = null;
                state.values.generation_name = null;
            }
            else if (action.payload.key === 'model_name') {
                state.values.generation_name = null;
            }
        },
        resetFilters: function (state) {
            state.values = {
                brand_name: null,
                model_name: null,
                generation_name: null,
                year_from: null,
                max_price: null,
                engine_name_type_name: null,
                gearbox_type_name: null,
                body_type_name: null,
                drive_type_name: null,
                owners_count: null,
            };
            state.state = {
                isLoading: false,
                filtersList: [],
                error: null,
                carCount: null,
            };
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(exports.loadFilters.fulfilled, function (state, action) {
            state.state.isLoading = false;
            var carCountItem = action.payload.find(function (item) { return item.key === 'car_count'; });
            var filters = action.payload.filter(function (item) { return item.key !== 'car_count'; });
            state.state.filtersList = filters;
            state.state.carCount = carCountItem ? Number(carCountItem.value) : null;
        })
            .addCase(exports.loadFilters.pending, function (state) {
            state.state.isLoading = true;
            state.state.error = null;
        })
            .addCase(exports.loadFilters.rejected, function (state, action) {
            state.state.isLoading = false;
            state.state.error = action.payload;
        });
    },
});
exports.setFilterValue = (_a = filterSlice.actions, _a.setFilterValue), exports.resetFilters = _a.resetFilters;
exports.default = filterSlice.reducer;
